export const NUMBER_ID = 'card-number-element'
export const CVC_ID = 'card-cvc-element'
export const EXPIRY_ID = 'card-expiry-element'